<template>
<div>
    <div class="print-wrap" v-if="info.isChangeItem && info.isChangeItem === 'true'">
      <h2 class="print-title">{{info.deliveryArea == '天津静海油库'? '天津三和众诚石油制品销售有限公司' : info.orgName + '装油 出门通知单'}}</h2>
        <div class="print-subtitle" v-if="info.deliveryArea != '天津静海油库'">
          <div>购物单位:{{info.customerName}}</div>
          <div>{{(new Date()).toLocaleString()}}</div>
          <div>编号:{{info.takeOrderCode}}</div>
        </div>
      <img :src="dialogImageUrl" class="img-print" v-show="printVisible"/>
      <table>
          <tr>
            <th>车号</th>
            <td>{{info.carNumber}}</td>
            <th>鹤位</th>
            <td colspan="3">{{info.craneCode}}  鹤位别名：{{info.craneName}}  厂区位置：{{info.craneDesc}}</td>
          </tr>
          <tr>
            <th>产品</th>
            <td>{{info.deliveryItem}}</td>
            <th>数量</th>
            <td>{{info.deliveryQuantity}}</td>
            <th>装油密码</th>
            <td>{{info.loadPassword}}</td>
          </tr>
          <tr>
            <th>前罐量</th>
            <td>{{info.firstTankQuantity}}</td>
            <th>中罐量</th>
            <td>{{info.secondTankQuantity}}</td>
            <th>后罐量</th>
            <td>{{info.thirdTankQuantity}}</td>
          </tr>
          <tr v-if="info.deliveryArea != '天津静海油库'">
            <th>皮重</th>
            <td></td>
            <th>毛重</th>
            <td></td>
            <th>净重</th>
            <td></td>
          </tr>
          <tr v-if="info.deliveryArea != '天津静海油库'">
            <th>制单人</th>
            <td>{{info.loginName}}</td>
            <th>备注</th>
            <td colspan="3">{{info.remark}}</td>
          </tr>
          <tr v-if="info.deliveryArea != '天津静海油库'">
            <td colspan="3">车辆装油方式：{{loadType[info.loadType]}}</td>
            <td colspan="3">协议编号：{{protocolCodes}}</td>
          </tr>
          <tr v-if="info.deliveryArea == '天津静海油库'">
            <th>司机姓名</th>
            <td>{{info.driverName}}</td>
            <th>身份证号</th>
            <td>{{info.identityCard}}</td>
            <th>手机号</th>
            <td>{{info.mobilePhone}}</td>
          </tr>
        </table>
        <div class="print-foot" v-if="info.deliveryArea != '天津静海油库'">
          <div class="print-foot-item">门卫签字：</div>
          <div class="print-foot-item">发货员签字：</div>
        </div>
        <div class="print-foot" v-if="info.deliveryArea == '天津静海油库'">
          <div class="print-foot-item">我公司委派以上车辆提货</div>
          <div class="print-foot-item" style="text-align: right"> {{info.deliveryArea == '天津静海油库'? info.orgName : '加能（大连）能源科技有限公司'}}</div>
        </div>
        <div class="print-foot" v-if="info.deliveryArea == '天津静海油库'">
          <div class="print-foot-item"></div>
          <div class="print-foot-item" style="text-align: right">{{new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月' + new Date().getDate() + '日'}}</div>
        </div>
    </div>
    <div class="print-wrap" v-if="info.isChangeItem && info.isChangeItem !== 'true'">
      <h3 style="color: red" class="print-title">获取打印{{info.orgName}}装油 出门通知单信息失败！</h3>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" @click="handlePrint">打 印</el-button>
    </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'printDialog',
  data () {
    return {
      dialogImageUrl: '',
      printVisible: false,
      info: {},
      loadType: {
        1: '上装',
        2: '下左',
        3: '下右',
        4: '下左右'
      }
    }
  },
  computed: {
    getId () {
      return this.$route.query.id
    },
    protocolCodes () {
      if (this.info.protocolCodes && this.info.protocolCodes.length > 0) {
        return this.info.protocolCodes.toString()
      }
      return ''
    }
  },
  methods: {
    ...mapActions(['billingDetail']),
    handlePrint () {
      window.print()
    }
  },
  mounted () {
    this.billingDetail({ id: this.getId, activityFlg: true }).then(res => {
      this.info = res
      if (this.info.orgName === '山东省石油化工有限公司') {
        // 省石化
        this.dialogImageUrl = 'https://jingbo-test.oss-cn-beijing.aliyuncs.com/%E7%9C%81%E7%9F%B3%E5%8C%96%E8%AE%A1%E9%87%8F%E4%B8%93%E7%94%A8%E7%AB%A0.jpg'
        this.printVisible = true
      } else if (this.info.orgName === '大连海益石油化工有限公司') {
        // 省石化
        this.dialogImageUrl = 'https://jingbo-test.oss-cn-beijing.aliyuncs.com/%E5%A4%A7%E8%BF%9E%E6%B5%B7%E7%9B%8A%E4%B8%93%E7%94%A8%E7%AB%A0.jpg'
        this.printVisible = true
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@media print {
  body{
    margin: 0;
    padding: 0;
  }
  .dialog-footer{
    display: none;
  }
}
@page {
  size:A5 landscape;
}
.formItem{
  text-align: center;
}
.el-form-item{
  margin-left: 0;
}
.print-subtitle{
  display: flex;
  font-size: 14px;
  padding: 2px 0;
  div{
    padding: 0 2px;
    flex:1;
  }
}
table
{
border-collapse: collapse;
border-spacing: 0px;
}
table, th, td
{
padding: 5px;
border: 1px solid black;
}
th,td{
  width: 100px;
  text-align: center;
  font-size: 14px;
}
.dialog-footer{
  margin-top: 80px;
  text-align: center;
}
.print-wrap{
  margin: 20px auto;
  width: 600px;
  .print-time{
    text-align: center;
  }
  .print-title{
    margin: 0;
    padding: 0;
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 20px;
  }
  .print-foot{
    margin-top: 15px;
    display: flex;
    font-size: 14px;
    .print-foot-item{
      flex: 1;
    }
  }
  .img-print {
    position: absolute;
    width: 120px;
    height: 120px;
    margin-left: 320px;
    margin-top: 130px;
  }
}
</style>
